import { createFileRoute } from '@tanstack/react-router'
import Sitelord from '../sitelord/Sitelord'

export const Route = createFileRoute('/_a/sitelord')({
  component: Sitelord,
})
